import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { brandService } from '../../services/brandService';
import toast from 'react-hot-toast';

interface BrandModalProps {
    isOpen: boolean;
    onClose: () => void;
    onSuccess: () => void;
}

export const BrandModal: React.FC<BrandModalProps> = ({ isOpen, onClose, onSuccess }) => {
    const [name, setName] = useState('');
    const [code, setCode] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!name.trim()) return;

        setLoading(true);
        try {
            await brandService.createBrand({ name, code });
            setName('');
            setCode('');
            onSuccess(); // Toast handled in parent or here? Parent does it.
            onClose();
        } catch (error: any) {
            toast.error(error.response?.data?.message || 'Error creating brand');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Nueva Marca">
            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label className="block text-sm font-medium text-gray-700">Nombre de la Marca</label>
                    <input
                        type="text"
                        required
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm"
                        value={name}
                        onChange={(e) => setName(e.target.value.toUpperCase())}
                        placeholder="Ej. PRONOVIAS"
                    />
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700">
                        Código (Opcional)
                        <span className="text-gray-400 text-xs ml-2">Para etiquetas QR</span>
                    </label>
                    <input
                        type="text"
                        maxLength={10}
                        className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 sm:text-sm font-mono"
                        value={code}
                        onChange={(e) => setCode(e.target.value.toUpperCase())}
                        placeholder="Ej. PRO (Auto-generado si vacío)"
                    />
                </div>
                <div className="mt-5 sm:mt-6 flex justify-end gap-3">
                    <button
                        type="button"
                        className="inline-flex justify-center rounded-md border border-gray-300 bg-white px-4 py-2 text-base font-medium text-gray-700 shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:text-sm"
                        onClick={onClose}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        disabled={loading}
                        className="inline-flex justify-center rounded-md border border-transparent bg-blue-600 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 sm:text-sm disabled:opacity-50"
                    >
                        {loading ? 'Guardando...' : 'Crear Marca'}
                    </button>
                </div>
            </form>
        </Modal>
    );
};
